const development = {
    apiGateway: {
        URL: "http://localhost:8000"
    }
}

const production = {
    apiGateway: {
        URL: "https://pes-prod.herokuapp.com"
    }
}

const config = process.env.REACT_APP_STAGE === 'production'
  ? production
  : development;

export default {
    VERSION: '0.0.0',
    ...config 
}